export default "__VITE_ASSET__bda9106d__"